const API_STAGE = process.env.VUE_APP_API_STAGE || 'betav1';

const SMS_BASE_URL = process.env.VUE_APP_SMS_BASE_URL || 'https://sms.nizosoft.com';
const HMS_BASE_URL = process.env.VUE_APP_HMS_BASE_URL || 'https://hms.nizosoft.com';
const UPLOAD_BASE_URL = process.env.VUE_APP_UPLOAD_BASE_URL || 'https://upload.nizosoft.com';
const EPAY_BASE_URL = process.env.VUE_APP_EPAY_BASE_URL || 'https://epay.nizosoft.com';
const CRM_BASE_URL = process.env.VUE_APP_CRM_BASE_URL || 'https://crm.nizosoft.com';
const ECMS_BASE_URL = process.env.VUE_APP_ECMS_BASE_URL || 'https://ecms.nizosoft.com';

const COMPLAINT_IMAGE_BASE_URL =
  process.env.VUE_APP_COMPLAINT_IMAGE_BASE_URL ||
  `https://s3.ap-south-1.amazonaws.com/data.eauth.nizosoft.com/nexthome4u-${API_STAGE}/complain`;

const SMS_API_BASE = `${SMS_BASE_URL}/${API_STAGE}`;
const HMS_API_BASE = `${HMS_BASE_URL}/${API_STAGE}`;
const UPLOAD_API_BASE = `${UPLOAD_BASE_URL}/${API_STAGE}`;
const EPAY_API_BASE = `${EPAY_BASE_URL}/${API_STAGE}`;
const CRM_API_BASE = `${CRM_BASE_URL}/${API_STAGE}`;
const ECMS_API_BASE = `${ECMS_BASE_URL}/${API_STAGE}`;

const PRODUCT_ID = process.env.VUE_APP_DEVICE_PRODUCT_ID || 'NEXTHOME4U';
const PRODUCT_KEY = process.env.VUE_APP_DEVICE_PRODUCT_KEY || '5oyqEvDSwzYWAC8B';
const APP_VERSION = process.env.VUE_APP_VERSION || '1.0.0';

const getComplaintImageUrl = (imageUrl) => {
  if (!imageUrl) return imageUrl;
  return imageUrl.startsWith('http') ? imageUrl : `${COMPLAINT_IMAGE_BASE_URL}/${imageUrl}`;
};

export {
  API_STAGE,
  SMS_BASE_URL,
  HMS_BASE_URL,
  UPLOAD_BASE_URL,
  EPAY_BASE_URL,
  CRM_BASE_URL,
  ECMS_BASE_URL,
  SMS_API_BASE,
  HMS_API_BASE,
  UPLOAD_API_BASE,
  EPAY_API_BASE,
  CRM_API_BASE,
  ECMS_API_BASE,
  COMPLAINT_IMAGE_BASE_URL,
  PRODUCT_ID,
  PRODUCT_KEY,
  APP_VERSION,
  getComplaintImageUrl,
};
